/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Vs_Desktop_DescInputs */

const en_wc_on_vs_desktop_desc = /** @type {(inputs: Wc_On_Vs_Desktop_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The online version is perfect for trying WordCraft or quick edits on any computer. For daily writing, the desktop app starts faster, uses native file dialogs and works without a connection.`)
};

/**
* | output |
* | --- |
* | "The online version is perfect for trying WordCraft or quick edits on any computer. For daily writing, the desktop app starts faster, uses native file dialogs..." |
*
* @param {Wc_On_Vs_Desktop_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_vs_desktop_desc = /** @type {((inputs?: Wc_On_Vs_Desktop_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Vs_Desktop_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_vs_desktop_desc(inputs)
});
export { wc_on_vs_desktop_desc as "wc.on.vs_desktop_desc" }